import { useState } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9mnlr4it35ii3jdlk70', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let serverMsg = '';
      try {
        const parsed = JSON.parse(responseText);
        serverMsg = parsed?.meta?.message || parsed?.message || '';
      } catch {
        serverMsg = responseText || '';
      }
      if (response.ok && !serverMsg.toLowerCase().includes('spam')) {
        setFormStatus('success');
        form.reset();
        setCharCount(0);
      } else {
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <p className="text-sm text-foreground-500">有任何问题或建议？欢迎给我们留言</p>
        </div>

        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          {/* Honeypot */}
          <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-foreground-400 mb-1.5">称呼</label>
              <input
                type="text"
                name="name"
                required
                className="w-full px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-lg text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                placeholder="请输入你的称呼"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-foreground-400 mb-1.5">邮箱</label>
              <input
                type="email"
                name="email"
                required
                className="w-full px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-lg text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                placeholder="请输入你的邮箱"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-400 mb-1.5">意见类型</label>
            <select
              name="type"
              className="w-full px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-lg text-sm text-foreground-100 focus:outline-none focus:border-primary-500/50 transition-colors cursor-pointer"
            >
              <option value="suggestion">功能建议</option>
              <option value="bug">问题反馈</option>
              <option value="content">内容需求</option>
              <option value="other">其他</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-400 mb-1.5">
              留言内容 <span className="text-foreground-600">({charCount}/500)</span>
            </label>
            <textarea
              name="message"
              required
              maxLength={500}
              rows={4}
              onChange={(e) => setCharCount(e.target.value.length)}
              className="w-full px-4 py-2.5 bg-background-100 border border-background-200/60 rounded-lg text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
              placeholder="请输入你的留言内容..."
            ></textarea>
          </div>
          <button
            type="submit"
            className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold rounded-lg text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            提交反馈
          </button>

          {formStatus === 'success' && (
            <p className="text-sm text-emerald-400 text-center">感谢你的反馈，我们会认真对待每一条留言！</p>
          )}
          {formStatus === 'error' && (
            <p className="text-sm text-red-400 text-center">{formError}</p>
          )}
        </form>
      </div>
    </section>
  );
}